/* Drivemax — valutasymbool voor vaste bedragen.

   Zet elementen met data-hv-fx-cents om naar de actieve valuta van de klant.
   Let op: het BEDRAG blijft gelijk, alleen het symbool en de notatie
   veranderen mee. 2,95 blijft 2,95 — in EUR wordt dat €2,95, in USD $2.95.
   Er wordt bewust geen wisselkoers toegepast. */
(function () {
  function actief() {
    var c = (window.Shopify && window.Shopify.currency) || {};
    return c.active || '';
  }

  function formatteer(bedrag, code) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
        style: 'currency',
        currency: code
      }).format(bedrag);
    } catch (e) {
      return bedrag.toFixed(2) + ' ' + code;
    }
  }

  function zet(el) {
    if (el.getAttribute('data-hv-fx-done') === '1') return;

    var cents = parseInt(el.getAttribute('data-hv-fx-cents'), 10);
    var basis = el.getAttribute('data-hv-fx-base') || 'EUR';
    var code = actief();

    /* geen andere valuta actief: originele tekst laten staan */
    if (!cents || !code || code === basis) {
      el.setAttribute('data-hv-fx-done', '1');
      return;
    }

    var prefix = el.getAttribute('data-hv-fx-prefix') || '';
    el.textContent = prefix + formatteer(cents / 100, code);
    el.setAttribute('data-hv-fx-done', '1');
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('[data-hv-fx-cents]:not([data-hv-fx-done="1"])');
    for (var i = 0; i < nodes.length; i++) zet(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  /* winkelwagen en drawer herschrijven hun HTML: opnieuw scannen */
  try {
    new MutationObserver(function () { scan(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  window.HV_FX_SCAN = scan;
})();
